import { CategorizedHPOOption } from '@/types/RequisitionFormTypes'
import { resolveHpoLabel, type GetHPOTermById } from './hpoLabelResolver'
import { mapWithConcurrency } from './hpoLookupCache'
import { isHpoCode } from './hpoTypes'

/** Stay under terminology search rate limits (burst 3 / ~10 per minute). */
const LOOKUP_CONCURRENCY = 2

/**
 * Updates HPO term labels by fetching the latest label from the HPO API when
 * the current label is still a raw HP code. Human-readable labels are kept.
 */
export async function updateHPOTermLabels(
  terms: CategorizedHPOOption[],
  getTermById: GetHPOTermById
): Promise<CategorizedHPOOption[]> {
  return mapWithConcurrency(terms, LOOKUP_CONCURRENCY, async (term) => {
    if (term.label?.trim() && !isHpoCode(term.label) && term.node?.lbl && !isHpoCode(term.node.lbl)) {
      return term
    }
    const resolved = await resolveHpoLabel(term, getTermById)
    if (resolved.label === term.label && resolved.id === term.id) {
      return term
    }
    return {
      ...term,
      id: resolved.id,
      label: resolved.label,
      node: { id: resolved.id, lbl: resolved.label, type: term.node?.type ?? 'PhenotypicFeature' },
    }
  })
}
